var syllableEs = require('syllable-es');

export const ShuffleArray = (sourceArray) => {

    let newArray = [...sourceArray];

    for (var i = 0; i < newArray.length - 1; i++) {
        var j = i + Math.floor(Math.random() * (newArray.length - i));

        var temp = newArray[j];
        newArray[j] = newArray[i];
        newArray[i] = temp;
    }

    console.log("Shuffling");

    return newArray;
}

export const SyllablesEng = (word) => {
  word = word.toLowerCase();                                     //word.downcase!
  if(word.length <= 3) { return 1; }                             //return 1 if word.length <= 3
    word = word.replace(/(?:[^laeiouy]es|ed|[^laeiouy]e)$/, '');   //word.sub!(/(?:[^laeiouy]es|ed|[^laeiouy]e)$/, '')
    word = word.replace(/^y/, '');                                 //word.sub!(/^y/, '')
    return word.match(/[aeiouy]{1,2}/g).length;                    //word.scan(/[aeiouy]{1,2}/).size
}

export const NumLetters = (str) => {
  const numLetters = str.length;
  return numLetters;
}

export const SyllablesEs = (word) => {
  return (word.length > 0) ? syllableEs(word) : 0;
}



// WEBPACK FOOTER //
// ./src/utils/HelperScripts.js